import store from '../store'
import axios from 'axios'

let instance
/* eslint-disable */
instance = axios.create()
instance.defaults.headers.common.client_id = 'geclisaAutoRecepcion'

instance.interceptors.request.use(async (config) => {
  const url = store.state.apiUrl
  config.baseURL = `${url}/api`
  store.commit('incrementAjaxCounter')
  return config
})

instance.interceptors.response.use(response => {
  store.commit('decrementAjaxCounter')
  return response
}, error => {
  // hay que hacer retry en los NOT FOUND porque a veces no alcanza a levantar el conn.json
  store.commit('decrementAjaxCounter')
  if (!error.config.__isRetryRequest && error.response.status == 404) {
    error.config.__isRetryRequest = true
    return axios(error.config)
  }
  return Promise.reject(error)
})
export default instance
